import { IProductOffer } from '../../types';
import { useTranslation } from 'react-i18next';

const usePercentageOffByMinSpendValue: IProductOffer = () => {
  const { t } = useTranslation(null, { keyPrefix: 'Features:Offers:OfferBadge' });

  return (offer) => {
    const isEligible = () => true;
    const badge =
      offer &&
      t(offer.kind, {
        percentageAmount: offer.details.percentage_amount,
      });

    return { isEligible, badge };
  };
};

export default usePercentageOffByMinSpendValue;
